import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTabNavPanel, MatTabNav, MatTabLink } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { ITopToolbarConfig } from '../../app-navigation/domain/top-toolbar.model';
import { TopToolbarManagerService } from '../../services/top-toolbar-manager.service';
import { ResponsiveService } from '../../services/responsive.service';

@Component({
  selector: 'app-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrl: './top-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatIcon,
    MatIconButton,
    MatTabNav,
    MatTabNavPanel,
    MatTabLink,
    MatBadge,
  ],
})
export class TopToolbarComponent {
  private readonly topToolbarManagerService = inject(TopToolbarManagerService);
  private readonly responsiveService = inject(ResponsiveService);

  public readonly topToolbarConfig = signal<ITopToolbarConfig | null>(null);
  public readonly isMobile = this.responsiveService.isMobile;

  // TODO For demo purposes only, in the future implement for notifications or warnings. With value 0 it is not displayed
  public notificationTopToolbarCount = signal<number>(3);

  constructor() {
    effect(() => {
      this.loadConfig();
    });
  }

  private async loadConfig(): Promise<void> {
    try {
      const config = await this.topToolbarManagerService.getTopToolbarConfig();
      this.topToolbarConfig.set(config);
    } catch (error) {
      console.error('Error loading top toolbar config:', error);
      this.topToolbarConfig.set(null);
    }
  }
}
